import { render, staticRenderFns } from "./DynamicMenu.vue?vue&type=template&id=98cf6caa&"
import script from "./DynamicMenu.vue?vue&type=script&lang=js&"
export * from "./DynamicMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports